module.exports = __webpack_public_path__ + "media/images/df-magazine-fall-2023-d70ccdba.png";